import React from "react";
import app1 from "../../assets/images/dashboard/app1.png";
import app2 from "../../assets/images/dashboard/app2.png";
import app3 from "../../assets/images/dashboard/app3.png";
import { Link } from "react-router-dom";

export const Application = () => {
  return (
    <div className="applicationContainer">
      <div className="appCard">
        <div className="appLeft">
          <div className="appLeftImg">
            <Link to="/application-details">
              <img src={app1} />
            </Link>
          </div>
          <div className="appLeftContent">
            <div>4BHK Villa</div>
            <div>Banjara Hills, Hyderabad</div>
            <div>
              <span>Application Status :</span>
              <span>Visit Enabled</span>
            </div>
            <div>{""}</div>
          </div>
        </div>
        <div className="appRight">
          <div>Price</div>
          <div className="appRightPrice">
            <span>₹75,00,000</span>
            <strike>₹85,00,000</strike>
          </div>
          <div>
            <button>Schedule Visit</button>
          </div>
        </div>
      </div>
      <div className="appCard">
        <div className="appLeft">
          <div className="appLeftImg">
            <Link to="/application-details">
              <img src={app2} />
            </Link>
          </div>
          <div className="appLeftContent">
            <div>4BHK Villa</div>
            <div>Banjara Hills, Hyderabad</div>
            <div>
              <span>Application Status :</span>
              <span>Visit Scheduled on 20 June, 2025</span>
            </div>
            <div>
              Location details have been sent to your registered mobile number
              and email.
            </div>
          </div>
        </div>
        <div className="appRight">
          <div>Price</div>
          <div className="appRightPrice">
            <span>₹75,00,000</span>
            <strike>₹85,00,000</strike>
          </div>
          <div>
            <button>Reschedule Visit</button>
          </div>
        </div>
      </div>
      <div className="appCard">
        <div className="appLeft">
          <div className="appLeftImg">
            <Link to="/application-details">
              <img src={app3} />
            </Link>
          </div>
          <div className="appLeftContent">
            <div>4BHK Villa</div>
            <div>Banjara Hills, Hyderabad</div>
            <div>
              <span>Initial Bidding Amount :</span>
              <span>₹ 76,00,000</span>
            </div>
            <div>Application Status : Invited for offline bidding</div>
          </div>
        </div>
        <div className="appRight">
          <div>Price</div>
          <div className="appRightPrice">
            <span>₹75,00,000</span>
            <strike>₹85,00,000</strike>
          </div>
          <div>
            <button>Pay Registration Fee</button>
          </div>
        </div>
      </div>
    </div>
  );
};
